var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutscanLcrBags(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1562_9129)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1562_9129)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1562_9129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 0H9.2C4.11898 0 0 4.11898 0 9.2V70C0 75.081 4.11898 79.2 9.2 79.2H70C75.081 79.2 79.2 75.081 79.2 70V9.2C79.2 4.11898 75.081 0 70 0Z",
    fill: "#F8FBFF",
    stroke: "#F0F2F5",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17.8379H20.6893V14.9999H10V17.8379Z",
    fill: "#262427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.487 40.4449H20.6895V58.2285H22.487V40.4449Z",
    fill: "#858694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8926 40.4449V58.2285H20.6891V40.4449H18.8926Z",
    fill: "#DCDBE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0202 50.0469H38.96V32.3496H59.0202V50.0469Z",
    fill: "#F9D044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4005 50.0469H59.0205V32.3496H66.4005V50.0469Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.627 41.4902L49.0059 40.498L48.3869 40.1416L49.9878 37.3693L48.5149 36.5196L46.9149 39.2919L46.2969 38.9346L46.627 41.4902Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7531 44.3116L47.7063 42.7477V43.4605H44.5054V45.1613H47.7063V45.875L49.7531 44.3116Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6129 40.188L50.2837 42.7427L50.9008 42.3864L52.5003 45.1582L53.9741 44.3085L52.3737 41.5362L52.9917 41.1798L50.6129 40.188Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7052 40.3455L50.146 37.6436L50.0002 37.8968L49.1641 39.3449L50.2107 41.1582L50.387 39.7955L51.7052 40.3455Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2204 40.4888L44.6641 43.1875H46.627L47.6924 41.3441L46.4014 41.882L46.2204 40.4888Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0972 45.1582H52.1837L51.2022 43.4569H49.0859L50.2053 44.3118L49.0972 45.1582Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3369 38.3164H40.5571V34.7446H45.3369V38.3164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6346 37.4824H41.0859V35.5772H41.6346V37.4824Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1619 37.4824H43.6123V35.5772H44.1619V37.4824Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3311 37.4824H42.6108V35.5772H43.3311V37.4824Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3973 37.4824H42.1226V35.5772H42.3973V37.4824Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.808 37.4824H44.5332V35.5772H44.808V37.4824Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4595 58.2294C26.4595 61.4162 23.8757 64 20.6891 64C17.5026 64 14.9189 61.4162 14.9189 58.2294C14.9189 55.043 17.5026 52.4597 20.6891 52.4597C23.8757 52.4597 26.4595 55.043 26.4595 58.2294Z",
    fill: "#262427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8655 58.2304C22.8655 59.4323 21.8915 60.4062 20.6895 60.4062C19.4879 60.4062 18.5142 59.4323 18.5142 58.2304C18.5142 57.0295 19.4879 56.0555 20.6895 56.0555C21.8915 56.0555 22.8655 57.0295 22.8655 58.2304Z",
    fill: "#858694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6356 60.3306C64.6356 62.3569 62.993 64 60.9672 64C58.9415 64 57.2983 62.3569 57.2983 60.3306C57.2983 58.3049 58.9415 56.6622 60.9672 56.6622C62.993 56.6622 64.6356 58.3049 64.6356 60.3306Z",
    fill: "#262427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9741 52.4588V58.2285H56.2345C57.0424 56.4166 58.8586 55.1481 60.9673 55.1481C63.0766 55.1481 64.8927 56.4166 65.6997 58.2285H70.0687V52.4588H27.9741Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3511 60.331C62.3511 61.0949 61.7317 61.7148 60.9673 61.7148C60.203 61.7148 59.584 61.0949 59.584 60.331C59.584 59.5662 60.203 58.9482 60.9673 58.9482C61.7317 58.9482 62.3511 59.5662 62.3511 60.331Z",
    fill: "#858694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.487 15.001H20.6895V40.4473H22.487V15.001Z",
    fill: "#262427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8926 15.001V40.4473H20.6891V15.001H18.8926Z",
    fill: "#858694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8926 29.8505V33.8227H24.2841V51.9022C26.4843 53.1571 27.9736 55.5195 27.9736 58.2285H32.7027V33.8227V29.8505H18.8926Z",
    fill: "#72A1DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0702 46.7842C30.0702 47.9082 29.1591 48.8184 28.0355 48.8184H17.2048C16.0818 48.8184 15.1714 47.9082 15.1714 46.7842C15.1714 45.6616 16.0818 44.7509 17.2048 44.7509H28.0355C29.1591 44.7509 30.0702 45.6616 30.0702 46.7842Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7026 49.8424H70.0681V52.459H32.7026V49.8424Z",
    fill: "#858694"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1562_9129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1562_9129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1562_9129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutscanLcrBags);
export default __webpack_public_path__ + "static/media/outscanLcrBags.de239cd251ff63933fa08eecf79af072.svg";
export { ForwardRef as ReactComponent };